export async function tryNTimes<T>({
  toTry,
  times = 3,
  interval = 1,
}: {
  toTry: () => Promise<T>;
  times?: number;
  interval?: number;
}): Promise<T> {
  if (times < 1)
    throw new Error(`Bad argument: 'times' must be greater than 0, but ${times} was received.`);
  let attemptCount = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    try {
      const result = await toTry();
      return result;
    } catch (error) {
      if (++attemptCount >= times) throw error;
    }
    await delay(interval);
  }
}

/**
 * @function delay Delays the execution of an action.
 * @param {number} time The time to wait in seconds.
 * @returns {Promise<void>}
 */
export function delay(time: number): Promise<void> {
  return new Promise<void>(resolve => setTimeout(resolve, time * 1000));
}
